/* Wappy Tarjeta: puntos de color, agregar al carrito con selector de talla, pestañas Mujer/Kids y carruseles.
   Funciona para todas las tarjetas de la página, aunque el archivo se cargue varias veces. */
(function () {
  if (window.wappyTarjeta) return;
  window.wappyTarjeta = true;

  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var LBL_ADD = 'Agregar al carrito';
  var LBL_OUT = 'Agotado';
  var LBL_ADDED = '¡Agregado!';

  /* Lista de tallas: id^nombre^disponible separadas por ~ */
  function parseList(str) {
    if (!str) return [];
    return str.split('~').map(function (row) {
      var p = row.split('^');
      return { id: p[0], label: p[1], avail: p[2] === '1' };
    }).filter(function (v) { return v.id; });
  }

  function closeSizes(card) {
    if (!card) return;
    var panel = card.querySelector('[data-wcard-sizes]');
    if (panel) panel.hidden = true;
    card.classList.remove('is-picking');
  }

  function updateCount() {
    fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var n = cart.item_count;
      document.querySelectorAll('.cart-link').forEach(function (link) {
        var icon = link.querySelector('.cart-link__icon') || link;
        var badge = link.querySelector('.cart-link__count');
        if (n > 0) {
          if (!badge) { badge = document.createElement('span'); badge.className = 'cart-link__count'; icon.appendChild(badge); }
          badge.textContent = n;
        } else if (badge) { badge.parentNode.removeChild(badge); }
      });
    }).catch(function () {});
  }

  function addToCart(card, id, url) {
    var btns = card.querySelectorAll('[data-wcard-add]');
    btns.forEach(function (b) { b.disabled = true; });
    /* Al agregar con fetch, el carrito lateral de Wappy se abre solo */
    return fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return r.json();
    }).then(function () {
      closeSizes(card);
      btns.forEach(function (b) { b.textContent = LBL_ADDED; });
      if (!window.WappyCarrito) updateCount();
      setTimeout(function () {
        btns.forEach(function (b) { b.textContent = LBL_ADD; b.disabled = false; });
      }, 1800);
    }).catch(function () {
      window.location.href = url;
    });
  }

  function openSizes(card, btn) {
    var panel = card.querySelector('[data-wcard-sizes]');
    var box = card.querySelector('[data-wcard-sizes-list]');
    if (!panel || !box) return;
    var list = parseList(btn.getAttribute('data-vlist'));
    var url = btn.getAttribute('data-url');
    box.innerHTML = '';
    list.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wcard__size';
      b.textContent = v.label;
      if (!v.avail) {
        b.disabled = true;
        b.setAttribute('aria-label', v.label + ' (agotado)');
      }
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        b.classList.add('is-busy');
        addToCart(card, v.id, url);
      });
      box.appendChild(b);
    });
    panel.hidden = false;
    card.classList.add('is-picking');
    var first = box.querySelector('.wcard__size:not([disabled])');
    if (first) first.focus({ preventScroll: true });
  }

  function pickColor(card, sw) {
    var d = sw.dataset;
    card.querySelectorAll('.wcard__sw').forEach(function (o) { o.classList.remove('is-on'); o.setAttribute('aria-pressed', 'false'); });
    sw.classList.add('is-on');
    sw.setAttribute('aria-pressed', 'true');
    card.classList.add('is-switched');
    var img = card.querySelector('.wcard__img1');
    if (img && d.img) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = d.img;
      img.alt = d.title || '';
    }
    card.querySelectorAll('[data-wcard-link]').forEach(function (a) { a.href = d.url; });
    var t = card.querySelector('[data-wcard-title]');
    if (t && d.title) t.textContent = d.title;
    var p = card.querySelector('[data-wcard-price]');
    if (p) p.textContent = d.price;
    var c = card.querySelector('[data-wcard-compare]');
    if (c) { c.textContent = d.compare || ''; c.hidden = !d.compare; }
    var priceBox = card.querySelector('.wcard__price');
    if (priceBox) priceBox.classList.toggle('is-sale', !!d.compare);
    var badge = card.querySelector('[data-wcard-sale]');
    if (badge) {
      if (d.pct && d.avail === 'true') {
        badge.textContent = badge.getAttribute('data-tpl').replace('[%]', d.pct);
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }
    card.querySelectorAll('[data-wcard-add]').forEach(function (b) {
      b.setAttribute('data-variant', d.variant);
      b.setAttribute('data-url', d.url);
      b.setAttribute('data-vlist', d.vlist || '');
      b.disabled = d.avail !== 'true';
      b.textContent = d.avail === 'true' ? LBL_ADD : LBL_OUT;
    });
    closeSizes(card);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    /* Cerrar selectores de talla abiertos al tocar afuera */
    document.querySelectorAll('.wcard.is-picking').forEach(function (card) {
      if (!card.contains(t)) closeSizes(card);
    });

    var x = t.closest && t.closest('[data-wcard-sizes-close]');
    if (x) { e.preventDefault(); closeSizes(x.closest('[data-wcard]')); return; }

    var sw = t.closest && t.closest('.wcard__sw');
    if (sw) { e.preventDefault(); pickColor(sw.closest('[data-wcard]'), sw); return; }

    var btn = t.closest && t.closest('[data-wcard-add]');
    if (btn) {
      e.preventDefault();
      if (btn.disabled) return;
      var card = btn.closest('[data-wcard]');
      var url = btn.getAttribute('data-url');
      var list = parseList(btn.getAttribute('data-vlist'));
      if (list.length > 1) {
        if (card.classList.contains('is-picking')) closeSizes(card);
        else openSizes(card, btn);
        return;
      }
      var id = list.length === 1 ? list[0].id : btn.getAttribute('data-variant');
      addToCart(card, id, url);
      return;
    }

    /* Pestañas Mujer / Kids */
    var tab = t.closest && t.closest('[data-wsec-tab]');
    if (tab) {
      var root = tab.closest('[data-wsec]');
      if (!root) return;
      var target = tab.getAttribute('data-wsec-tab');
      root.querySelectorAll('[data-wsec-tab]').forEach(function (o) {
        o.setAttribute('aria-selected', o === tab ? 'true' : 'false');
      });
      root.querySelectorAll('[data-wsec-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-wsec-panel') !== target;
      });
      root.querySelectorAll('[data-wsec-row]').forEach(updateArrows);
      return;
    }

    /* Flechas de carrusel */
    var arrow = t.closest && t.closest('[data-wsec-arrow]');
    if (arrow) {
      var row = arrow.closest('.wsec__wrap').querySelector('[data-wsec-row]');
      var step = Math.max(row.clientWidth * 0.8, 200);
      row.scrollBy({ left: arrow.getAttribute('data-wsec-arrow') === 'next' ? step : -step, behavior: 'smooth' });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.wcard.is-picking').forEach(closeSizes);
  });

  function updateArrows(row) {
    var wrap = row.closest('.wsec__wrap');
    if (!wrap) return;
    var prev = wrap.querySelector('[data-wsec-arrow="prev"]');
    var next = wrap.querySelector('[data-wsec-arrow="next"]');
    var max = row.scrollWidth - row.clientWidth - 2;
    if (prev) prev.disabled = row.scrollLeft <= 2;
    if (next) next.disabled = row.scrollLeft >= max;
    /* Barra que muestra cuánto se ha deslizado */
    var bar = wrap.querySelector('.wsec__bar');
    if (bar) {
      var thumb = bar.firstChild;
      var total = row.scrollWidth;
      var hasMore = total > row.clientWidth + 2;
      bar.hidden = !hasMore;
      if (hasMore) {
        var size = row.clientWidth / total;
        var pos = row.scrollLeft / total;
        thumb.style.width = (size * 100) + '%';
        thumb.style.left = (pos * 100) + '%';
      }
    }
  }
  /* Pequeño movimiento la primera vez que se ve un carrusel en celular */
  var nudgeObs = null;
  function nudge(row) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.innerWidth >= 750) return;
    if (row.scrollLeft > 2 || row.scrollWidth <= row.clientWidth + 2) return;
    row.style.scrollSnapType = 'none';
    row.scrollTo({ left: 56, behavior: 'smooth' });
    setTimeout(function () {
      row.scrollTo({ left: 0, behavior: 'smooth' });
      setTimeout(function () { row.style.scrollSnapType = ''; }, 500);
    }, 650);
  }
  function watchNudge(row) {
    if (!('IntersectionObserver' in window)) return;
    if (!nudgeObs) {
      nudgeObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio >= 0.6) {
            nudgeObs.unobserve(en.target);
            setTimeout(function () { nudge(en.target); }, 400);
          }
        });
      }, { threshold: [0.6] });
    }
    nudgeObs.observe(row);
  }
  function initRows(scope) {
    (scope || document).querySelectorAll('[data-wsec-row]').forEach(function (row) {
      if (row.getAttribute('data-ready')) { updateArrows(row); return; }
      row.setAttribute('data-ready', '1');
      var wrap = row.closest('.wsec__wrap');
      if (wrap && !wrap.querySelector('.wsec__bar')) {
        var bar = document.createElement('div');
        bar.className = 'wsec__bar';
        bar.setAttribute('aria-hidden', 'true');
        bar.appendChild(document.createElement('span'));
        wrap.appendChild(bar);
      }
      row.addEventListener('scroll', function () { updateArrows(row); }, { passive: true });
      updateArrows(row);
    });
  }
  /* Abre la pestaña Kids si la dirección termina en #kids */
  function initHash() {
    var hash = (window.location.hash || '').replace('#', '').toLowerCase();
    if (!hash) return;
    document.querySelectorAll('[data-wsec] [data-wsec-tab="' + hash + '"]').forEach(function (tab) { tab.click(); });
  }
  window.wappyCarruseles = function (scope) { initRows(scope); };
  function start() { initRows(); initHash(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('resize', function () { initRows(); });
  document.addEventListener('shopify:section:load', function (e) { initRows(e.target); });
})();